import { render } from "./AOA_VT_BUYS.vue?vue&type=template&id=e6cc2654"
import script from "./AOA_VT_BUYS.vue?vue&type=script&lang=js"
export * from "./AOA_VT_BUYS.vue?vue&type=script&lang=js"

import "./AOA_VT_BUYS.vue?vue&type=style&index=0&id=e6cc2654&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__